import { getGatewayBaseUrl } from '../../services/apiService';
import { apiCall, createApiThunk } from '../../utils/api';
import { ChangePasswordState } from './changePasswordSlice';

export const resetTimeThunk = createApiThunk('RESET_TIME_CHANGE_PASSWORD', apiCall);

export const startLoadingReducer = (state: ChangePasswordState) => {
  state.loading = true;
};

export const stopLoadingReducer = (state: ChangePasswordState) => {
  state.loading = false;
};

export const changePasswordResetTime = () => (dispatch: AppDispatch) => {
  dispatch(resetTimeThunk({ url: `${getGatewayBaseUrl()}/auth/resettime`, method: 'GET' }));
};
